import { Link } from 'gatsby';
import React, { useState } from 'react';
import styled from 'styled-components';
import Navigation from './Navigation';
import IconHamburger from '../atoms/iconHamburger';
import IconCross from '../atoms/iconCross';
import Logo from '../atoms/Logo';

const Holder = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;
  min-height: ${props => props.open ? '100vh' : '0'};
  padding: 1rem;
  z-index: 10;
  @media(${props => props.theme.breakpoints.md}) {
    display: none;
  }
  .title-row {
    margin-bottom: ${props => props.open ? '2rem' : '0'};
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  svg line { stroke: ${props => props.theme.colours.black} }
`;

const NavHolder = styled.div`
  display: ${props => props.open ? 'block' : 'none'};
  margin-top: 4rem;
`;

function SmallHeader() {

  const [ open, setOpen ] = useState( false );

  return (
    <Holder open={open}>

      <TitleRow>
        <Link to="/"><Logo/></Link>
        <button className="icon" onClick={() => setOpen( !open )}>
          {open ? <IconCross/> : <IconHamburger/>}
        </button>
      </TitleRow>

      <NavHolder open={open}>
        <Navigation onLinkClick={() => setOpen( false )}/>
      </NavHolder>

    </Holder>
  )
}

export default SmallHeader
